/* eb8fbe5098a93681b71a1064d88531ce751fed41
 * This file is automatically generated by graphql-let. */

import * as Types from '../../../../__types__';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrderMutationVariables = Types.Exact<{
  order: Types.OrderInput;
}>;


export type OrderMutation = { __typename?: 'Mutation', createOrder?: { __typename?: 'OrderResponse', status?: boolean | null, error?: string | null, success?: boolean | null, paymentId?: string | null, packages?: Array<{ __typename?: 'SelectedPackage', uri?: string | null } | null> | null, payu?: { __typename?: 'PayUResponse', payu_order_response?: { __typename?: 'PayUOrderResponse', redirectUri?: string | null, status?: { __typename?: 'PayUOrderResponseStatus', statusCode?: Types.PayUOrderResponseStatusCode | null } | null } | null } | null } | null };


export const OrderDocument = gql`
    mutation Order($order: OrderInput!) {
  createOrder(orderInput: $order) {
    status
    error
    success
    paymentId
    packages {
      uri
    }
    payu {
      payu_order_response {
        status {
          statusCode
        }
        redirectUri
      }
    }
  }
}
    `;
export type OrderMutationFn = Apollo.MutationFunction<OrderMutation, OrderMutationVariables>;

/**
 * __useOrderMutation__
 *
 * To run a mutation, you first call `useOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderMutation, { data, loading, error }] = useOrderMutation({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useOrderMutation(baseOptions?: Apollo.MutationHookOptions<OrderMutation, OrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderMutation, OrderMutationVariables>(OrderDocument, options);
      }
export type OrderMutationHookResult = ReturnType<typeof useOrderMutation>;
export type OrderMutationResult = Apollo.MutationResult<OrderMutation>;
export type OrderMutationOptions = Apollo.BaseMutationOptions<OrderMutation, OrderMutationVariables>;